import "./Notice.scss";

const Notice = () => {
  return (
    <div className="notice-container">
      <p>
        <b>Important Account Update:</b>&nbsp;
        We have upgraded our system. To continue using your account, please set a new password&nbsp;
        <a href="https://my.mtab.se/account/set-password" target="_blank" rel="noopener noreferrer">
          here
        </a>.
      </p>
    </div>
  );
};

export default Notice;
